// React Libraries
import React, { createContext, useContext, useState } from 'react';

// Created a context that stores the selected ticket data and provides it to the components that need it.
const TicketDataContext = createContext();

// Custom hook to use the TicketContext
export function useTicketData() {
    return useContext(TicketDataContext);
}

// function that provides the ticket data to the its children components that need it
export function TicketDataProvider({ children }) {
    const [ticketData, setTicketData] = useState({ tickets: [], totalTickets: 0 });
    const [attendeeDetails, setAttendeeDetails] = useState({ attendees: [] });

    // Function that adds or removes a ticket
    function addTicket(ticketId, ticketInfo) {
        setTicketData((prevData) => {
            // Filter out any existing ticket with the same ticketId. if same ticketId is found then it will remove that ticket
            const updatedTickets = prevData.tickets.filter(
                (ticket) => ticket.ticketId !== ticketId
            );

            // If ticketInfo is provided and quantity is greater than 0, create attendees array with empty values
            if (ticketInfo && ticketInfo.quantity > 0) {
                // const attendees = [];

                // Add the new ticket data with attendees
                updatedTickets.push({
                    ticketId,
                    ...ticketInfo
                    // attendees
                });
            }

            const totalTickets = updatedTickets.reduce((acc, ticket) => acc + ticket.quantity, 0);
            // Return the new ticket data in object format
            return { tickets: updatedTickets, totalTickets };
        });
    }

    // function to save attendees data
    function saveAttendees(ticketIndex, attendeesData) {
        setTicketData((prevData) => {
            const updatedTickets = [...prevData.tickets];
            updatedTickets[ticketIndex].attendees = attendeesData;
            return { tickets: updatedTickets };
        });
    }

    // function that stored the attendee details with their selected ticketId
    function storeAttendeesDetails(ticketIndex, attendeesData) {
        setAttendeeDetails((prevData) => {
            const addAttendees = [...prevData.attendees];
            addAttendees[ticketIndex] = attendeesData;
            console.log('Attendees Details', addAttendees);
            return { attendees: addAttendees };
        });
    }

    // Provide the ticket data and functions to the children components
    return (
        <TicketDataContext.Provider
            value={{ ticketData, addTicket, saveAttendees, storeAttendeesDetails, attendeeDetails }}
        >
            {children}
        </TicketDataContext.Provider>
    );
}
